'use es6';

import { map } from 'rxjs/operators/map';
import http from 'hub-http-rxjs/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import Settings from '../models/Settings';
const SETTINGS_BASE_PATH = 'content-settings/v1/site-settings/by-portal-id';
export default {
  fetch() {
    return http.get(`${SETTINGS_BASE_PATH}/${PortalIdParser.get()}`).pipe(map(Settings.fromJS));
  }

};